module.exports = __webpack_public_path__ + "static/Glober_Regular-5894fbc2745d8f03a1b2ca505527dca8.woff";